/** @format */
import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Box,
  IconButton,
} from "@mui/material";
import useMode from "hooks/useMode";
import { SelectCus, TextCus } from "components";
import { fontSize } from "theme";
import { UserOptions } from "./UserOptions";
import { IActionTopbar } from "types/actions";
import { Icons } from "assets";
import { useUser } from "hooks";

const typeOptions = [
  { id: "apartment", name: "アパート", selected: true },
  { id: "house", name: "家" },
];

const Header = ({ namePage }: { namePage: string }) => {
  const { setPtype, ptype } = useUser()
  const mode = useMode();
  const [state, setState] = useState<any>({

  });

  const handleActionTopbar = (action: IActionTopbar) => (e?: unknown) => {
    if (action === 'showUser')
      return setState(old => ({
        ...old,
        anchorUserPop: (e as React.MouseEvent<HTMLButtonElement>)?.currentTarget,
      }));
  };

  return (
    <AppBar
      position="static"
      color="default"
      elevation={0}
      style={{ borderBottom: "1px solid #ccc", backgroundColor: mode?.primary }}
    >
      <Toolbar sx={{ justifyContent: "space-between", background: mode?.primary }}>
        <TextCus color={mode?.secondary} fontSize={fontSize.md}>
          {namePage}
        </TextCus>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          {/* <IconButton>
            <Notifications sx={{ color: mode?.secondary }} />
          </IconButton> */}
          <Box minWidth={70} ml={3}>
            <SelectCus
              isShowLabel
              options={typeOptions}
              value={ptype}
              onChange={(e) => setPtype(e.target.value)}
            />
          </Box>
          <Box onClick={(e) => handleActionTopbar('showUser')(e)} display={"flex"} alignItems={"center"} gap={1}>
            <IconButton>{Icons.User(mode?.secondary)}</IconButton>
            <TextCus
              color={mode?.secondary}
              fontWeight={600}
              fontSize={fontSize.sm}
            >
              Administrator
            </TextCus>
          </Box>
          <UserOptions
            isOpen={state.anchorUserPop || null}
            onClose={handleActionTopbar('showUser')}
          />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
